import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import GroupsAPI from '../../../../utils/api/groupsAPI';

const entity = new ReduxRestEntity({
  name: 'groups',
  api: GroupsAPI(),
});

export default entity;
